export const associationsConstants = {
  INIT: 'ASSOCIATIONS_INIT',
  SUCCESS: 'ASSOCIATIONS_SUCCESS',
  ADD: 'ASSOCIATIONS_ADD',
  UPDATE: 'ASSOCIATIONS_UPDATE',
  FAILURE: 'ASSOCIATIONS_FAILURE',
  REMOVE: 'ASSOCIATIONS_REMOVE',
  CLEAR: 'ASSOCIATIONS_CLEAR',
}
